import React, { useId } from 'react'
import PropTypes from 'prop-types'

const DevicesIcon = React.forwardRef(function DevicesIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3C2.45228 3 2 3.45228 2 4V16C2 16.5477 2.45228 17 3 17H6.79C7.34228 17 7.79 17.4477 7.79 18 7.79 18.5523 7.34228 19 6.79 19H3C1.34772 19 0 17.6523 0 16V4C0 2.34772 1.34772 1 3 1H21C21.5523 1 22 1.44772 22 2 22 2.55228 21.5523 3 21 3H3ZM16 18.5C16 17.6716 16.6716 17 17.5 17 18.3284 17 19 17.6716 19 18.5 19 19.3284 18.3284 20 17.5 20 16.6716 20 16 19.3284 16 18.5Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 7C13.4523 7 13 7.45228 13 8V20C13 20.5477 13.4523 21 14 21H21C21.5477 21 22 20.5477 22 20V8C22 7.45228 21.5477 7 21 7H14ZM11 8C11 6.34772 12.3477 5 14 5H21C22.6523 5 24 6.34772 24 8V20C24 21.6523 22.6523 23 21 23H14C12.3477 23 11 21.6523 11 20V8Z"
      ></path>
    </svg>
  )
})

DevicesIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

DevicesIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default DevicesIcon
